import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMinimize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="m6.13 12.81-3.66 3.66a.75.75 0 0 0 1.06 1.06l3.661-3.66V17a.75.75 0 0 0 1.5 0v-4.94a.75.75 0 0 0-.75-.75H3a.75.75 0 0 0 0 1.5zm5.236-4.582a.75.75 0 0 0 .693.463H17a.75.75 0 1 0 0-1.5h-3.13l3.66-3.661a.75.75 0 1 0-1.06-1.06l-3.661 3.66V3a.75.75 0 0 0-1.5 0v4.94q0 .154.057.288" />
  </svg>
);
export default SvgMinimize;
